/**
 * ================================================================
 * Bisou Rivage — bisou-fiche.js
 * ================================================================
 * Les quatre petits gestes de la fiche produit, et rien d'autre.
 * Ce fichier ne touche NI au panier, NI aux variantes, NI a la
 * galerie : il se contente de declencher ce qui existe deja.
 *
 *   1. AGRANDIR — le bouton hors image clique le declencheur de zoom
 *      du theme sur la diapo active. Le modal, le focus et la
 *      fermeture restent ceux de Shopify.
 *   2. EDITION LIMITEE — le badge dore fait basculer le BLOC GRIS de
 *      gauche : le fond passe au noir, l'oeuvre retrecit et glisse vers
 *      la droite, le texte arrive a gauche lettre apres lettre. C'est un
 *      etat de la fiche, pas une page : rien ne navigue, rien n'est
 *      recouvert.
 *   3. REFERENCE — l'infobulle du H-020. Survol gere en CSS ; ici on
 *      ne s'occupe que du tap mobile, qui n'a pas de survol.
 *   4. LE VIDE SOUS LE PREMIER ECRAN — a l'ordinateur, la suite de la
 *      colonne de droite remonte en douceur dans ce vide quand on defile.
 * ================================================================
 */
(function () {
  'use strict';

  /* ══════════════════ 1. AGRANDIR ══════════════════
     La loupe a quitte le coin du mockup : plus rien ne se superpose au
     tirage. Le bouton vit au-dessus de la colonne image et delegue au
     bouton de zoom natif de la diapo visible. */
  function activeZoomTrigger() {
    var active = document.querySelector('.product__media-item.is-active')
              || document.querySelector('.product__media-item');
    var trigger = active && active.querySelector('.product__media-toggle');
    /* Diapo « mise en situation » (mockup maison) : elle n'a pas de modal
       natif, on retombe sur la premiere diapo qui en a un. */
    return trigger || document.querySelector('.product__media-toggle');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-rv5-expand]');
    if (!btn) return;
    e.preventDefault();
    var trigger = activeZoomTrigger();
    if (!trigger) return;
    trigger.click();
    /* A la fermeture, Dawn rend le focus au declencheur (global.js,
       removeTrapFocus(this.openedBy)) : ici un bouton de 0 x 0 px, le
       focus disparaissait. On le rend a « Agrandir », celui qu'on a
       touche (accessibilite, 25/10). show() a deja lu openedBy. */
    var modal = document.querySelector('product-modal[open]');
    if (modal) modal.openedBy = btn;
  });

  /* Clavier (accessibilite, 25/10) :
     - les declencheurs de zoom de Dawn font 0 x 0 px ici (la loupe a
       quitte l'image) : ils prenaient le focus sans qu'on le voie.
       « Agrandir » les remplace au clavier ; la souris et le doigt
       les gardent. */
  function rv5Clavier() {
    var tools = document.querySelector('.rv5-media-tools');
    if (!tools || !tools.querySelector('[data-rv5-expand]')) return;
    /* La liste qui defile aussi : sans enfant focusable, Chrome la rend
       focusable a son tour. Les points et les fleches la font defiler. */
    document.querySelectorAll('.rv5-media-frame .product__media-toggle, .rv5-media-frame .product__media-list').forEach(function (t) {
      t.setAttribute('tabindex', '-1');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rv5Clavier);
  } else {
    rv5Clavier();
  }

  /* Le clic sur le TIRAGE ouvre aussi le plein ecran, sur ordinateur (Max,
     28/08). Dawn pose deja un calque cliquable sur chaque diapo
     (.product__media-toggle::after) : quand c'est lui qui prend le clic, la
     cible est le bouton, pas l'image, et on ne fait rien de plus — pas de
     double ouverture. On ne rattrape que le clic qui atteint l'image. La
     diapo « mise en situation » n'a pas de modal : on la laisse. */
  document.addEventListener('click', function (e) {
    var img = e.target.closest && e.target.closest('.rv5-media-frame .product__media-item img');
    if (!img) return;
    if (e.target.closest('.rv5-mk-slide')) return;
    var large = false;
    try { large = window.matchMedia('(min-width: 900px)').matches; } catch (err) {}
    if (!large) return;
    var trigger = activeZoomTrigger();
    if (trigger) trigger.click();
  });

  /* ── Zoom dans le plein ecran, a la souris et au doigt (Max, 28/08) ──
     Chez Dawn, un clic souris N'IMPORTE OU dans la modale la ferme
     (global.js:610, `pointerup` sur .media-modal) — l'image comprise. Ici le
     clic sur l'image ne ferme plus : il double l'image, centree sur le point
     clique, et le second clic la rend entiere. Le clic a cote ferme toujours.

     On ecoute le meme `pointerup`, mais en phase de CAPTURE sur document :
     on passe avant la modale, et stopPropagation l'empeche de fermer. Seul
     le clic sur l'image active est intercepte, rien d'autre ne change.

     Au doigt aussi (21/10) : au telephone, le plein ecran d'un tirage
     horizontal n'etait pas plus grand que la fiche (370 px contre 358). Le
     toucher sur l'image la double comme le clic. Faire glisser l'image
     zoomee ne la rend pas entiere : le navigateur annule alors le pointeur,
     sans `pointerup`. Un second doigt pose en meme temps est ignore.

     Un zoom qui ne survit pas a la fermeture : quand l'attribut `open` tombe,
     on remet l'image entiere, sinon la modale rouvrirait zoomee sur un autre
     tirage. */
  function modalImage(target) {
    return target.closest && target.closest('.product-media-modal__content > .active');
  }

  function dezoomer(modal) {
    if (!modal) return;
    modal.classList.remove('rv5-zoomed');
    var imgs = modal.querySelectorAll('.product-media-modal__content > *');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].style.width = '';
      imgs[i].style.height = '';
      imgs[i].style.marginTop = '';
      if (imgs[i].hasAttribute('data-rv5-sizes')) {
        imgs[i].setAttribute('sizes', imgs[i].getAttribute('data-rv5-sizes'));
        imgs[i].removeAttribute('data-rv5-sizes');
      }
    }
  }

  function zoomer(img, e) {
    var modal = img.closest('.product-media-modal');
    var content = img.closest('.product-media-modal__content');
    if (!modal || !content) return;
    var rect = img.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    /* Le point clique, en fraction de l'image : c'est lui qu'on garde sous le
       curseur apres le zoom. */
    var rx = (e.clientX - rect.left) / rect.width;
    var ry = (e.clientY - rect.top) / rect.height;
    var w = Math.round(rect.width * 2);
    var h = Math.round(rect.height * 2);

    /* Une source plus fine pour la taille doublee : `sizes` decide du candidat
       que le navigateur charge, pas la largeur CSS. */
    if (!img.hasAttribute('data-rv5-sizes')) {
      img.setAttribute('data-rv5-sizes', img.getAttribute('sizes') || '');
    }
    img.setAttribute('sizes', w + 'px');

    modal.classList.add('rv5-zoomed');
    img.style.width = w + 'px';
    img.style.height = 'auto';
    /* Au telephone, un tirage horizontal double reste moins haut que l'ecran :
       il reste centre en hauteur au lieu de se coller en haut. */
    img.style.marginTop = Math.max(0, Math.round((content.clientHeight - h) / 2)) + 'px';

    var cr = content.getBoundingClientRect();
    content.scrollLeft = img.offsetLeft + rx * w - (e.clientX - cr.left);
    content.scrollTop  = img.offsetTop  + ry * h - (e.clientY - cr.top);
  }

  /* Zoome, on se deplace dans l'image (Max, 26/10 : « quand on zoom on doit aussi ensuite pouvoir faire defiler » ;
     fiche a26-fiche-commandes-image) : a la souris ou au stylet, on la fait glisser (le conteneur defile sous le
     pointeur) ; la molette et le pave defilaient deja, le doigt aussi (defilement natif). Un glisse ne dezoome pas :
     seul un clic sans deplacement rend l'image entiere, la croix et Echap ferment toujours. */
  var glisse = null;
  document.addEventListener('pointerdown', function (e) {
    glisse = null;
    if (!e.isPrimary || e.pointerType === 'touch' || e.button !== 0) return;
    var img = modalImage(e.target);
    var modal = img && img.closest('.product-media-modal');
    if (!modal || !modal.classList.contains('rv5-zoomed')) return;
    var content = img.closest('.product-media-modal__content');
    e.preventDefault();
    glisse = { content: content, x: e.clientX, y: e.clientY, l: content.scrollLeft, t: content.scrollTop, bouge: false };
  }, true);
  document.addEventListener('pointermove', function (e) {
    if (!glisse || !e.isPrimary) return;
    var dx = e.clientX - glisse.x, dy = e.clientY - glisse.y;
    if (!glisse.bouge && Math.abs(dx) + Math.abs(dy) < 5) return;
    if (!glisse.bouge) { glisse.bouge = true; glisse.content.classList.add('rv5-glisse'); }
    glisse.content.scrollLeft = glisse.l - dx;
    glisse.content.scrollTop = glisse.t - dy;
  }, true);
  var finGlisse = function () {
    var g = glisse;
    glisse = null;
    if (g) g.content.classList.remove('rv5-glisse');
    return !!(g && g.bouge);
  };
  document.addEventListener('pointercancel', finGlisse, true);
  document.addEventListener('dragstart', function (e) {
    if (modalImage(e.target)) e.preventDefault();
  }, true);

  document.addEventListener('pointerup', function (e) {
    if (!e.isPrimary) return;
    /* un glisse lache hors de l'image (sur le fond) ne ferme pas la modale non plus */
    if (finGlisse()) { e.stopPropagation(); return; }
    var img = modalImage(e.target);
    if (!img) return;
    var modal = img.closest('.product-media-modal');
    if (!modal || !modal.hasAttribute('open')) return;
    e.stopPropagation();
    if (modal.classList.contains('rv5-zoomed')) dezoomer(modal);
    else zoomer(img, e);
  }, true);

  /* Retour a l'image entiere a la fermeture. */
  (function veillerFermeture() {
    var modal = document.querySelector('product-modal.product-media-modal');
    if (!modal || typeof MutationObserver === 'undefined') return;
    new MutationObserver(function () {
      if (!modal.hasAttribute('open')) dezoomer(modal);
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  })();

  /* ══════════════════ 2. PANNEAU EDITION LIMITEE ══════════════════
     Le badge dore ne pose plus un calque : il change l'ETAT DU BLOC GRIS.
     Le fond vire au noir, l'oeuvre retrecit et glisse vers la droite, le
     texte prend la place liberee a gauche. Tout le dessin est dans la
     feuille (assets/bisou-variant-ui.css) ; ici on ne fait que poser deux
     classes et decouper le texte.

     Le panneau ne demenage plus sous <body>. Il l'a fait le 26/08 pour qu'un
     `position: fixed` se cale enfin sur la fenetre — un ancetre portait un
     `transform` et capturait le bloc englobant. Il n'y a plus de `fixed` du
     tout : le panneau est cale en absolu sur .product__media-wrapper, qui EST
     la zone grise. Le probleme n'existe plus, le contournement non plus. */
  function stage() { return document.querySelector('.rv5-media-stage'); }
  function badges() { return document.querySelectorAll('.rv5-edition-tag--gold'); }
  function panel() { return document.getElementById('rv5-edition-panel'); }
  function grey() {
    var pa = panel();
    return pa && pa.closest('.product__media-wrapper');
  }

  var MOINS_DE_MOUVEMENT = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── LE TEXTE QUI ARRIVE LETTRE APRES LETTRE ──
     Un <span> par MOT, un <span> par LETTRE dedans. Le niveau MOT n'est pas
     decoratif : sans lui, `display: inline-block` sur chaque lettre autorise
     la ligne a se couper au milieu d'un mot. Avec, elle se coupe encore la ou
     il faut.

     Le pas se CALCULE pour que chaque bloc mette a peu pres le meme temps a
     se remplir, quelle que soit sa longueur. Un pas fixe donnerait 250 ms au
     titre et quatre secondes au paragraphe : on attendrait la fin.

     PAS DE JUMEAU INVISIBLE (Max, 27/08). Le premier jet sortait le texte
     decoupe de l'arbre d'accessibilite et posait a cote une copie
     `visually-hidden`, technique habituelle contre les lecteurs d'ecran qui
     epellent les <span>. Max a vu le titre TROIS fois dans le texte de la
     page : l'exergue, le titre, et la copie. Invisible a l'oeil, mais bien la
     au copier-coller et dans l'arbre du document.

     Le niveau MOT rend la copie inutile : les lettres sont regroupees en mots,
     et un lecteur d'ecran lit le texte rendu, pas la liste des balises. Un mot
     reste un mot. On garde donc UNE seule fois chaque phrase.

     Le decoupage lit `textContent` : le texte servi doit rester du texte nu.
     C'est le cas — product.edition_panel.title et .body sont deux chaines
     simples des locales. Une balise posee dedans serait perdue. */
  var CIBLES = '[data-rv5-reveal]';
  var DUREE_REMPLISSAGE = 900; /* ms que met un bloc a se remplir, environ */

  function decouper(el, base) {
    if (el.__rv5Decoupe) return;

    var texte = el.textContent;
    var lettres = texte.replace(/\s+/g, '').length;
    if (!lettres) { el.__rv5Decoupe = true; return; }
    var pas = Math.min(20, DUREE_REMPLISSAGE / lettres);

    el.textContent = '';
    var rang = 0;

    texte.split(/(\s+)/).forEach(function (bout) {
      if (!bout) return;
      if (/^\s+$/.test(bout)) {
        el.appendChild(document.createTextNode(bout));
        return;
      }
      var mot = document.createElement('span');
      mot.className = 'rv5-rv-word';
      for (var i = 0; i < bout.length; i++) {
        var lettre = document.createElement('span');
        lettre.className = 'rv5-rv-char';
        lettre.textContent = bout.charAt(i);
        lettre.style.transitionDelay = Math.round(base + rang * pas) + 'ms';
        mot.appendChild(lettre);
        rang++;
      }
      el.appendChild(mot);
    });

    el.__rv5Decoupe = true;
  }

  function textes() {
    var pa = panel();
    return pa ? Array.prototype.slice.call(pa.querySelectorAll(CIBLES)) : [];
  }

  /* Le paragraphe part APRES le titre : deux textes qui se remplissent en
     meme temps se lisent comme du bruit. Le retard vaut la duree du titre. */
  function reveler() {
    var blocs = textes();
    if (MOINS_DE_MOUVEMENT) {
      blocs.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    blocs.forEach(function (el, i) { decouper(el, i * 320); });
    /* Deux trames avant d'armer : le navigateur doit avoir peint l'etat de
       depart, sinon il n'y a pas de transition, juste un saut. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        blocs.forEach(function (el) { el.classList.add('is-revealed'); });
      });
    });
  }

  function cacher() {
    textes().forEach(function (el) { el.classList.remove('is-revealed'); });
  }

  /* ── b27 : LE TIRAGE SANS CADRE, EN GRAND (Max, 27/10) ──
     « On n'a pas besoin d'avoir le morceau avec un cadre. » A l'ouverture, le
     panneau recoit le tirage seul, marge blanche comprise : l'image de la
     variante « sans cadre » du FORMAT choisi, lue dans le JSON des variantes
     de snippets/bisou-variant-ui.liquid (memes mots que findVariantId()). Les
     deux compteurs passent dans un cartel, sous la mention « Edite en N
     exemplaires » deja ecrite sur la fiche, traduite, suivie du format.
     Aucun texte neuf, aucune cle neuve. Sans image sans cadre : rien ne
     change, l'ancien panneau. Le panneau ouvert, changer de format change
     le tirage : updateEditionPanel() reecrit le compteur, on l'ecoute. */
  var SANS_CADRE = /sans|no frame|unframed|papier|paper/;

  function varianteCourante() {
    var s = document.querySelector('script[id^="rv5-variants-"]');
    var vs = [];
    try { vs = s ? JSON.parse(s.textContent) || [] : []; } catch (e) { vs = []; }
    var inp = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = inp ? String(inp.value) : '';
    var cur = null;
    for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === id) cur = vs[i];
    return { vs: vs, cur: cur || vs[0] || null };
  }

  function tirageSansCadre() {
    var v = varianteCourante();
    var fmt = v.cur && v.cur.o && v.cur.o[0] ? String(v.cur.o[0]) : '';
    var repli = null;
    for (var i = 0; i < v.vs.length; i++) {
      var t = v.vs[i].t || '';
      if (!v.vs[i].img || !SANS_CADRE.test(t)) continue;
      if (fmt && t.indexOf(fmt.toLowerCase()) !== -1) return { src: v.vs[i].img, fmt: fmt };
      if (!repli) repli = v.vs[i].img;
    }
    return { src: repli, fmt: fmt };
  }

  /* L'image « sans cadre » est un canevas : le papier y flotte dans une marge
     transparente (96 % du canevas en A2, a peine plus de la moitie en A4). On
     mesure le papier une fois l'image chargee — meme origine, la toile se lit —
     et on l'agrandit jusqu'au bord de sa place. Si la mesure echoue : l'image
     telle quelle. */
  function mesurerPapier(img) {
    img.style.transform = '';
    img.style.removeProperty('--ed-rogne');
    /* Tirage vertical : au telephone, le bloc grandit pour le cartel (CSS). */
    if (img.parentNode && img.parentNode.classList) {
      img.parentNode.classList.toggle('is-vertical', img.naturalHeight > img.naturalWidth);
    }
    try {
      var w = 160, h = Math.max(1, Math.round(160 * img.naturalHeight / img.naturalWidth));
      var c = document.createElement('canvas');
      c.width = w; c.height = h;
      var cx2 = c.getContext('2d');
      cx2.drawImage(img, 0, 0, w, h);
      var d = cx2.getImageData(0, 0, w, h).data;
      var x0 = w, y0 = h, x1 = -1, y1 = -1;
      for (var j = 0; j < h; j++) {
        for (var i = 0; i < w; i++) {
          if (d[(j * w + i) * 4 + 3] > 128) {
            if (i < x0) x0 = i; if (i > x1) x1 = i;
            if (j < y0) y0 = j; if (j > y1) y1 = j;
          }
        }
      }
      if (x1 < 0) return;
      var fw = (x1 - x0 + 1) / w, fh = (y1 - y0 + 1) / h;
      if (fw > 0.97 && fh > 0.97) return;
      var k = Math.min(1 / fw, 1 / fh);
      var cx = (x0 + (x1 - x0 + 1) / 2) / w, cy = (y0 + (y1 - y0 + 1) / 2) / h;
      img.style.transform = 'scale(' + k.toFixed(4) + ') translate(' +
        ((0.5 - cx) * 100).toFixed(3) + '%, ' + ((0.5 - cy) * 100).toFixed(3) + '%)';
      /* Canevas horizontal : au telephone, la boite garde la hauteur du canevas, plus haute que
         le papier agrandi. Ce qu'il en reste en haut et en bas, en % de la largeur (unite des
         marges), sert au CSS pour resserrer la boite sur le papier. */
      if (img.naturalWidth >= img.naturalHeight && fh * k < 1) {
        var rogne = (1 - fh * k) / 2 * (img.naturalHeight / img.naturalWidth) * 100;
        img.style.setProperty('--ed-rogne', rogne.toFixed(3) + '%');
      }
    } catch (e) { img.style.transform = ''; }
  }

  function preparerTirage() {
    var pa = panel();
    if (!pa) return;
    var info = tirageSansCadre();
    var fig = pa.querySelector('.rv5-ed-print');
    if (!fig && info.src) {
      fig = document.createElement('figure');
      fig.className = 'rv5-ed-print';
      fig.setAttribute('aria-hidden', 'true');
      var im = document.createElement('img');
      im.alt = '';
      im.decoding = 'async';
      im.addEventListener('load', function () { mesurerPapier(im); });
      fig.appendChild(im);
      pa.appendChild(fig);
    }
    if (fig) {
      var img = fig.querySelector('img');
      if (info.src && img.getAttribute('src') !== info.src) { img.style.transform = ''; img.src = info.src; }
      fig.hidden = !info.src;
    }
    pa.classList.toggle('has-print', !!info.src);

    var facts = pa.querySelector('.rv5-edition-panel__facts');
    if (!facts) return;
    var cartel = facts.parentNode.classList.contains('rv5-ed-cartel') ? facts.parentNode : null;
    if (!cartel) {
      cartel = document.createElement('div');
      cartel.className = 'rv5-ed-cartel';
      facts.parentNode.insertBefore(cartel, facts);
      cartel.appendChild(facts);
    }
    var note = document.querySelector('.rv5-edition-aside');
    var texte = note ? note.textContent.replace(/\s+/g, ' ').trim() : '';
    var ed = cartel.querySelector('.rv5-ed-cartel__ed');
    if (texte) {
      if (!ed) {
        ed = document.createElement('p');
        ed.className = 'rv5-ed-cartel__ed';
        cartel.insertBefore(ed, facts);
      }
      /* La mention a gauche, le format a droite : sur une colonne etroite, le format ne
         tombe jamais seul a la ligne. */
      ed.textContent = '';
      var m = document.createElement('span');
      m.textContent = texte;
      ed.appendChild(m);
      if (info.fmt) {
        /* un espace pour la lecture vocale (« exemplaires A3 ») ; le flex ne l'affiche pas */
        ed.appendChild(document.createTextNode(' '));
        var fm = document.createElement('span');
        fm.className = 'rv5-ed-cartel__fmt';
        fm.textContent = info.fmt;
        ed.appendChild(fm);
      }
    } else if (ed) {
      ed.parentNode.removeChild(ed);
    }
  }

  (function suivreLeFormat() {
    var rem = document.querySelector('[data-rv5-edition-remaining]');
    if (!rem || !window.MutationObserver) return;
    new MutationObserver(function () {
      var pa = panel();
      if (pa && pa.classList.contains('is-open')) preparerTirage();
    }).observe(rem, { childList: true, characterData: true, subtree: true });
  })();

  function setEdition(open) {
    var st = stage();
    var pa = panel();
    var gr = grey();
    if (!pa || !gr) return;
    if (open) preparerTirage();

    /* La zone grise porte l'etat : c'est ELLE qui change de couleur, elle qui
       recule l'oeuvre, elle qui efface la barre d'outils. */
    gr.classList.toggle('rv5-edition-on', open);
    /* La scene garde son ancienne classe : quelques regles heritees s'y
       accrochent encore (.rv5-media-actions sur telephone). */
    if (st) st.classList.toggle('rv5-edition-open', open);

    pa.classList.toggle('is-open', open);
    pa.setAttribute('aria-hidden', open ? 'false' : 'true');

    Array.prototype.forEach.call(badges(), function (b) {
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.classList.toggle('is-on', open);
    });

    if (open) {
      reveler();
      var close = pa.querySelector('[data-rv5-edition-close]');
      if (close) close.focus();
    } else {
      cacher();
    }
  }

  function editionIsOpen() {
    var gr = grey();
    return !!(gr && gr.classList.contains('rv5-edition-on'));
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    /* Le badge ouvre ET referme : deuxieme clic = retour au gris. */
    var badge = e.target.closest('.rv5-edition-tag--gold');
    if (badge) {
      e.preventDefault();
      setEdition(!editionIsOpen());
      return;
    }

    if (e.target.closest('[data-rv5-edition-close]')) {
      e.preventDefault();
      setEdition(false);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && editionIsOpen()) setEdition(false);
  });

  /* ══════════════════ 3. INFOBULLE REFERENCE (tap mobile) ══════════════════
     Le survol est fait en CSS (apparition apres 300 ms). Sur un ecran
     tactile il n'y a pas de survol : le tap montre l'infobulle 1,5 s. */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-rv5-tip]');
    if (!chip) return;
    chip.classList.add('is-tapped');
    clearTimeout(chip.__tipTimer);
    chip.__tipTimer = setTimeout(function () {
      chip.classList.remove('is-tapped');
    }, 1500);
  });

  /* ══════════════════ 4. LE VIDE SOUS LE PREMIER ECRAN ══════════════════
     Max, 20/10 : « Le vide doit etre present au debut pour garder le
     contenu du bloc de droite centre. Puis quand on scroll ce dernier
     remonte [...] faut trouver qqc de smooth ». A l'ordinateur (900 px et
     plus), .bisou-s1-wrapper fait un ecran de haut et centre son contenu
     (assets/bisou-variant-ui.css) : sous ce contenu, un vide. Page en
     haut, il reste. Des qu'on defile, la suite de la colonne remonte dans
     ce vide et l'a comble avant que le contenu quitte l'ecran ; au retour
     en haut, il se rouvre de meme. Une marge negative sous le premier
     ecran, calculee sur la position de la page : ni minuterie, ni retard,
     ni rebond, et rien ne bouge a gauche. Le contenu change de hauteur
     (format, « En savoir plus ») ou la fenetre de taille : on remesure. */
  (function () {
    var wrap = document.querySelector('.bisou-s1-wrapper');
    var inner = wrap && wrap.querySelector('.bisou-s1-sticky');
    if (!wrap || !inner || !window.matchMedia) return;
    var mq = window.matchMedia('(min-width: 900px)');
    var AIR = 24;            /* l'espace qui reste sous le contenu, vide comble */
    var vide = 0, course = 1, frame = 0;
    /* L'ancien « Associez-le », tant qu'il est affiche, arme le defilement
       aimante de bisou-mockup.js, qui vise sa cible page en haut, sans cette
       marge : la page sauterait apres l'atterrissage. Le geste s'efface donc,
       au meme test que l'aimant. bisou-duo.js le cache apres coup : il est
       observe, on remesure a ce moment-la. */
    var ancien = document.getElementById('rv5-bloc-associated');
    function ancienAffiche() {
      return !!(ancien && ancien.offsetParent && ancien.getBoundingClientRect().height >= 20);
    }

    function appliquer() {
      frame = 0;
      if (!vide) { wrap.style.removeProperty('margin-bottom'); return; }
      var p = Math.min(1, Math.max(0, (window.pageYOffset || 0) / course));
      var doux = p * p * (3 - 2 * p);   /* demarre et s'arrete en douceur */
      wrap.style.setProperty('margin-bottom', (-vide * doux).toFixed(1) + 'px', 'important');
    }
    /* 22/10 (v7-8) : a l'ordinateur, la barre d'Associez-le pend sous le
       contenu, en absolu (assets/bisou-mockup.css) : hors de sa boite, mais
       le vide se compte sous elle, sinon la suite remonte dessus. */
    function basContenu() {
      var bas = inner.getBoundingClientRect().bottom;
      var barre = inner.querySelector(':scope > .bvf-assoc-teaser');
      if (barre && barre.offsetParent) bas = Math.max(bas, barre.getBoundingClientRect().bottom);
      return bas;
    }
    /* La marge est sous le bloc : elle ne change ni sa boite ni celle du
       contenu, la mesure reste juste quelle que soit la position. */
    function mesurer() {
      vide = 0;
      if (mq.matches && window.getComputedStyle(inner).position !== 'sticky' && !ancienAffiche()) {
        vide = Math.max(0, Math.round(wrap.getBoundingClientRect().bottom - basContenu() - AIR));
        /* Comble sur deux fois sa hauteur de defilement, un tiers d'ecran au
           moins : la suite monte au plus 1,75 fois plus vite que la page. */
        course = Math.max(vide * 2, window.innerHeight / 3);
      }
      appliquer();
    }
    window.addEventListener('scroll', function () {
      if (!frame) frame = window.requestAnimationFrame(appliquer);
    }, { passive: true });
    window.addEventListener('resize', mesurer);
    if (mq.addEventListener) mq.addEventListener('change', mesurer);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(mesurer);
      ro.observe(wrap);
      ro.observe(inner);
      if (ancien) ro.observe(ancien);
      /* La barre arrive apres coup (bisou-duo.js) et, en absolu, ne change
         pas la taille du contenu : on l'observe elle-meme des qu'elle est la. */
      var barreVue = null;
      var suivreBarre = function () {
        var barre = inner.querySelector(':scope > .bvf-assoc-teaser');
        if (barre && barre !== barreVue) { barreVue = barre; ro.observe(barre); }
      };
      suivreBarre();
      if (window.MutationObserver) new MutationObserver(suivreBarre).observe(inner, { childList: true });
    }
    mesurer();
  })();
})();
